import React from 'react';
import CustomModal from '../../../components/Modal/CustomModal';
import CustomAddChipSearch from '../../../components/CustomAddChipSearch';
import SelectedFolioCard from './SelectedFolioCard';
import { TABLES } from '../../../Apis/Tables';
import { POSITION_MODEL } from '../../../Helpers/PositionModel';
import { gateFolioListToLabel } from '../Model/Model';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Folio the gate looks up by hand when the QR code cannot be scanned.
 *
 * The folios the search offers are the ones the QR code is issued for, so the
 * card the folio is selected with says what it was requested for and which
 * movement the gate still has to register on it.
 *
 * @param {Function} t Translation function.
 * @param {boolean} show Flag that opens the modal.
 * @param {Object|null} selectedFolio Folio the gate picked.
 * @param {Function} setSelectedFolio Writes the folio the gate picked.
 * @param {Function} onHide Leaves the modal and returns to the camera.
 * @param {Function} onConfirm Opens the detail of the selected folio.
 * @returns {JSX.Element}
 */
const ManualFolioModal = ({
    t,
    show,
    selectedFolio,
    setSelectedFolio,
    onHide,
    onConfirm,
}) => {
    return (
        <CustomModal
            title={'enter_folio_manually'}
            show={show}
            size='md'
            buttonConfirm='open_request'
            buttonCancelText='cancel'
            confirmButton={true}
            cancelButton={true}
            disabled={!selectedFolio?.id}
            onHide={onHide}
            onConfirm={onConfirm}
        >
            <div className={'row'}>
                <div className={'col-12 mb-4'}>
                    <p className={'fs-14px ibl-font-w-400 font-color-shades-500 mb-0'}>
                        {t('enter_the_folio_number_when_the_qr_code_cannot_be_scanned')}
                    </p>
                </div>

                <div className={'col-12'}>
                    {/* The gate opens one detail at a time, so the folio that was
                        picked is read in its own card and the chips of the search
                        are left out: the search is disabled while a folio is held
                        and is searched again once the card is removed */}
                    <CustomAddChipSearch
                        autocompleteId={'slt_mfm_folio_number'}
                        buttonId={'btn_mfm_add_folio_number'}
                        label={'folio_number'}
                        selectedList={[]}
                        setSelectedList={(list) => setSelectedFolio(list?.[list.length - 1]?.item || null)}
                        required={true}
                        hideButton={true}
                        showRenderOption={true}
                        keyId={'id'}
                        model={TABLES.MATERIAL_CONTROL_GATE_FOLIO}
                        sanitizeDataList={gateFolioListToLabel}
                        chipIcon={null}
                        positionIconOptions={POSITION_MODEL.LEFT}
                        iconFullHeight={true}
                        disabled={!!selectedFolio?.id}
                    />

                    {selectedFolio &&
                        <SelectedFolioCard
                            folio={selectedFolio}
                            onRemove={() => setSelectedFolio(null)}
                        />
                    }
                </div>
            </div>
        </CustomModal>
    );
};

export default ManualFolioModal;
